import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3000To3099Service {

  constructor() { }
}
